import formatters from '../shared/formatters';

// Warm amber (never red) signals a data-quality flag without implying the client is in a
// bad state. Ordinary zero-hour clients stay on the neutral palette.
export const FLAG_ROW_BACKGROUND = '#FBF4EA';
export const FLAG_ACCENT_COLOR = '#B57A2E';

// Six compact summary cards on wide screens, collapsing responsively below. Shared by the
// summary grid and by the section-level loading skeleton so both stay in step.
export const summaryGridColumns = {
  xs: '1fr',
  sm: 'repeat(2, minmax(0, 1fr))',
  md: 'repeat(3, minmax(0, 1fr))',
  lg: 'repeat(6, minmax(0, 1fr))',
};

export const TABLE_COLUMNS = [
  {key: 'client', sortKey: 'clientName', align: 'left', headerExpression: 'metrics.ClientMetrics.ClientMonthly.Table.Client'},
  {key: 'hourlyRate', sortKey: 'hourlyRate', align: 'right', headerExpression: 'metrics.ClientMetrics.ClientMonthly.Table.HourlyRate'},
  {key: 'scheduledHours', sortKey: 'scheduledHours', align: 'right', headerExpression: 'metrics.ClientMetrics.ClientMonthly.Table.ScheduledHours'},
  {key: 'weightedHours', sortKey: 'weightedHours', align: 'right', headerExpression: 'metrics.ClientMetrics.ClientMonthly.Table.WeightedHours'},
  {key: 'estimatedRevenue', sortKey: 'estimatedRevenue', align: 'right', headerExpression: 'metrics.ClientMetrics.ClientMonthly.Table.EstimatedRevenue'},
  {key: 'status', sortKey: null, align: 'left', headerExpression: 'metrics.ClientMetrics.ClientMonthly.Table.Status'},
];

export const DEFAULT_SORT = {key: 'estimatedRevenue', direction: 'desc'};

export const hasMissingRate = (client) => {
  return Boolean(client?.missingRate) || formatters.isMissingValue(client?.hourlyRate);
};

export const getUnpricedHours = (client) => {
  return formatters.isMissingValue(client?.unpricedHours) ? 0 : client.unpricedHours;
};

export const isFlaggedClient = (client) => {
  return hasMissingRate(client) || getUnpricedHours(client) > 0;
};

// Missing numbers (e.g. clients without a rate) always sink to the bottom regardless of
// direction; ties break on clientRn so the order stays stable as more pages append.
export const compareClients = (left, right, sortKey, sortDirection) => {
  const directionMultiplier = sortDirection === 'asc' ? 1 : -1;
  const tiebreak = (left.clientRn || '').localeCompare(right.clientRn || '');

  if (sortKey === 'clientName') {
    const comparison = (left.clientName || '').localeCompare(right.clientName || '', undefined, {sensitivity: 'base'});

    return comparison !== 0 ? directionMultiplier * comparison : tiebreak;
  }

  const leftValue = left?.[sortKey];
  const rightValue = right?.[sortKey];
  const leftMissing = formatters.isMissingValue(leftValue);
  const rightMissing = formatters.isMissingValue(rightValue);

  if (leftMissing && rightMissing) {
    return tiebreak;
  }

  if (leftMissing) {
    return 1;
  }

  if (rightMissing) {
    return -1;
  }

  return leftValue !== rightValue ? directionMultiplier * (leftValue - rightValue) : tiebreak;
};
